import { configureStore, combineReducers } from '@reduxjs/toolkit';
import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

import authReducer, { user, auth } from './slices/authSlice';
import loadReducer, { load } from './slices/loadSlice';
import dialogReducer, { dialog } from './slices/dialogSlice';
import themeReducer, { theme } from './slices/themeSlice';

const rootReducer = combineReducers({
  auth: authReducer,
  load: loadReducer,
  dialog: dialogReducer,
  theme: themeReducer,
});

export type RootState = ReturnType<typeof rootReducer>;

/**
 * Cria uma store nova. A aplicacao usa a instancia unica exportada abaixo; os
 * testes usam a fabrica para ter estado isolado em cada caso, sem vazar de um
 * teste para o outro.
 */
export const criarStore = (preloadedState?: Partial<RootState>) =>
  configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
      }),
    preloadedState,
  });

export const store = criarStore();

export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export default {
  dialog,
  load,
  user,
  auth,
  theme,
};
